<template>
  <div>
    <base-card :option="cardOption">
      <div slot="cardBody">
        <search-form @setSearchCondition="setSearchCondition" @clearSearch="clearSearch"></search-form>
        <!--      操作按钮-->
        <div class="table-operator">
          <template v-if="$auth('suppliers.edit')">
            <a-button type="primary" icon="plus" @click="handleAdd">新增</a-button>
          </template>
        </div>
        <!--表格-->
        <a-table
          :columns="table.columns"
          :rowKey="record => record.id"
          :dataSource="table.data"
          :pagination="pagination"
          :loading="table.loading"
          @change="handleTableChange"
        >
          <!--filterDropdown-->
          <div
            slot="filterDropdown"
            slot-scope="{ setSelectedKeys, selectedKeys, confirm, clearFilters, column }"
            style="padding: 8px"
          >
            <a-input
              v-ant-ref="c => searchInput = c"
              :placeholder="`请输入${column.title}`"
              :value="selectedKeys[0]"
              @change="e => setSelectedKeys(e.target.value ? [e.target.value] : [])"
              @pressEnter="() => handleSearch(selectedKeys, confirm)"
              style="width: 188px; margin-bottom: 8px; display: block;"
            />
            <a-button
              type="primary"
              @click="() => handleSearch(selectedKeys, confirm)"
              icon="search"
              size="small"
              style="width: 90px; margin-right: 8px"
            >搜索
            </a-button
            >
            <a-button
              ref="clearBtn"
              @click="() => handleReset(clearFilters)"
              size="small"
              style="width: 90px"
            >重置
            </a-button
            >
          </div>
          <a-icon
            slot="filterIcon"
            slot-scope="filtered"
            type="search"
            :style="{ color: filtered ? '#108ee9' : undefined }"
          />
          <span slot="roles" slot-scope="roles">
            <a-tag v-for="(role,index) in roles" :key="index">
              {{ role.label }}
            </a-tag>
          </span>
          <span slot="status" slot-scope="text,record">
            <a-tag v-if="record.status===1" :color="record.status ===1 ? 'green' : 'volcano'">
              正常
            </a-tag>
            <a-tag v-if="record.status===2" :color="record.status ===1 ? 'green' : 'volcano'">
              异常
            </a-tag>
          </span>
          <template slot="actions" slot-scope="text, record">
            <a href="javascript:;" @click="()=>handleView(record)">查看</a>
            <template v-if="$auth('suppliers.delete')">
              <a-divider type="vertical"/>
              <a href="javascript:;" @click="()=>handleEdit(record)">编辑</a>
            </template>
            <template v-if="$auth('suppliers.edit')">
              <a-divider type="vertical"/>
              <a-popconfirm
                v-if="table.data.length"
                title="确定要删除吗?"
                @confirm="() => setStatus(record,9)"
              >
                <a href="javascript:;">删除</a>
              </a-popconfirm>
            </template>

            <!--            <a-divider type="vertical"/>-->
            <!--            <a href="javascript:;" @click="()=>setProject(record)">招标项目</a>-->
            <template v-if="record.status===2">
              <template v-if="$auth('suppliers.start')">
                <a-divider type="vertical"></a-divider>
                <a-popconfirm
                  v-if="table.data.length"
                  title="确定要启用吗?"
                  @confirm="() => setStatus(record,1)"
                >
                  <a href="javascript:;">启用</a>
                </a-popconfirm>
              </template>
            </template>
            <template v-if="record.status===1">
              <template v-if="$auth('suppliers.disabled')">
                <a-divider type="vertical"></a-divider>
                <a-popconfirm
                  v-if="table.data.length"
                  title="确定要禁用吗?"
                  @confirm="() => setStatus(record,2)"
                >
                  <a href="javascript:;">禁用</a>
                </a-popconfirm>
              </template>
            </template>
          </template>
        </a-table>
      </div>
    </base-card>
    <!--各种弹出组件-->
    <edit-modal ref="editModal" @refreshTable="initTableData"></edit-modal>
  </div>
</template>

<script>
import { getSupplierList, editSupplierStatus } from '@/api/supplier'
import editModal from './modules/editModal'
import searchForm from './modules/searchForm'
import baseCard from '@/CrComponents/Card/Card'

export default {
  name: 'SupplierList',
  mounted () {
    this.searchModel = { ...this.pagination }
    this.initTableData()
  },
  computed: {},
  components: {
    editModal,
    searchForm,
    baseCard
  },
  data () {
    return {
      // card相关属性设置
      cardOption: {},
      // 搜索form中的参数
      searchFormModel: {},
      // 所有搜索条件 包括分页，搜素框，表格上筛选条件
      searchModel: {},
      // 表格中的查询条件
      searchTableModel: {},
      // 高级搜索 展开/关闭
      searchInput: null,
      searchText: '',
      selectedRows: [],
      rowSelection: {
        onChange: (selectedRowKeys, selectedRows) => {
          this.selectedRows = selectedRows
        },
        onSelect: (record, selected, selectedRows) => {
          this.selectedRows = selectedRows
        },
        onSelectAll: (selected, selectedRows, changeRows) => {
          this.selectedRows = selectedRows
        }
      },
      pagination: {
        pageNum: 1,
        pageSize: 10,
        total: 0,
        showSizeChanger: true,
        showQuickJumper: true
      },
      table: {
        data: [],
        columns: [
          {
            title: '供应商名称',
            dataIndex: 'name',
            width: '25%'
          },
          {
            title: '统一社会信用代码',
            dataIndex: 'number',
            width: '25%'
          },
          {
            title: '状态',
            dataIndex: 'status',
            customRender: (text) => {
              if (text === 1) {
                return '启用'
              } else if (text === 2) {
                return '禁用'
              }
            }
          },
          {
            title: '备注',
            dataIndex: 'remark'
          },
          {
            title: '操作',
            scopedSlots:
              { customRender: 'actions' }
          }
        ],
        searchCondition: {},
        loading: false,
        filteredInfo: null,
        sortedInfo: null
      }
    }
  },
  methods: {
    // 搜索
    setSearchCondition (searchFormModel) {
      this.searchFormModel = searchFormModel
      this.searchModel = { ...this.pagination, ...this.searchTableModel, ...searchFormModel }
      this.initTableData()
    },
    // 重置
    clearSearch (searchFormModel) {
      this.searchFormModel = searchFormModel
      this.pagination.pageNum = 1
      this.searchModel = { ...this.pagination, ...this.searchTableModel }
      this.table.filteredInfo = null
      this.table.sortedInfo = null
      delete this.searchModel.sortField
      delete this.searchModel.sortOrder
      this.initTableData()
    },
    // 表格中的搜索
    handleSearch (selectedKeys, confirm) {
      confirm()
      this.searchText = selectedKeys[0]
    },
    // 表格中的重置
    handleReset (clearFilters) {
      clearFilters()
      this.searchText = ''
    },
    // 初始化表格数据
    initTableData () {
      this.table.loading = true
      getSupplierList(this.searchModel).then(res => {
        if (res.status === 0) {
          this.table.loading = false
          this.table.data = res.data.list
          this.pagination.total = res.data.total
        } else {
          this.$message.error('获取数据失败！')
        }
      })
    },
    // 切换页码等操作
    handleTableChange (pagination, filters, sorter) {
      this.table.filteredInfo = filters
      this.table.sortedInfo = sorter
      this.pagination.pageSize = pagination.pageSize
      this.pagination.pageNum = pagination.current
      this.pagination.current = pagination.current
      this.searchModel = {
        ...this.searchFormModel,
        ...this.pagination,
        ...this.searchTableModel,
        sortField: sorter.field,
        sortOrder: sorter.order
      }
      this.initTableData()
    },
    // 删除操作
    setStatus (model, status) {
      editSupplierStatus({
        id: model.id,
        status: status
      }).then(res => {
        if (res.status === 0) {
          this.$message.success(res.info.message)
          this.initTableData()
        } else {
          this.$message.error(res.info.message)
        }
      })
    },
    // 查看详情
    handleView (model) {
      this.$refs.editModal.setTitle('查看供应商')
      this.$refs.editModal.setType(this.$sysInfo.MODAL_VIEW)
      this.$refs.editModal.setModel(model) // 先设置类型，再打开
      this.$refs.editModal.open(true)
    },
    // 编辑
    handleEdit (model) {
      this.$refs.editModal.setTitle('编辑供应商')
      this.$refs.editModal.setType(this.$sysInfo.MODAL_MODIFY)
      this.$refs.editModal.setModel(model)// 先设置类型，再打开
      this.$refs.editModal.open(true)
    },
    // 新增
    handleAdd () {
      this.$refs.editModal.setTitle('新增供应商')
      this.$refs.editModal.setType(this.$sysInfo.MODAL_ADD)// 先设置类型，再打开
      this.$refs.editModal.open(true)
    }
  }
}
</script>

<style scoped>

</style>
